module.exports = __webpack_public_path__ + "img/icon-poster-mode.0a877827.svg";